import RabbitFestivalMainBanner from "./components/banner";
import RabbitFestivalMainCompetition from "./components/competition";
import RabbitFestivalMainInterview from "./components/interview";
import RabbitFestivalMainNews from "./components/news";
import RabbitFestivalMainRank from "./components/rank";
import { FestivalMainContent, FestivalMainWrapper } from "./style";

const RabbitFestivalMain = () => {
  return (
    <FestivalMainWrapper>
      <RabbitFestivalMainBanner />
      <RabbitFestivalMainCompetition />
      <FestivalMainContent>
        <RabbitFestivalMainRank />
        <RabbitFestivalMainInterview />
        <RabbitFestivalMainNews />
      </FestivalMainContent>
    </FestivalMainWrapper>
  );
};

export default RabbitFestivalMain;
